import { ProductCollectionOverlayTemplate } from '@/components/signup/layouts/product-overlay-template';
import { ReturnToProduct } from '@/components/signup/site-activation/components/common/return-to-product';
import { SiteActivation } from '@/components/signup/site-activation/site-activation';

import { Headings } from '../components/headings';
import { PickUpWhereYouLeftOffText } from '../components/sub-heading';
import { WelcomeBackText } from '../components/welcome-back-heading';

export const ProductCollectionCurrentProductUser = () => (
	<ProductCollectionOverlayTemplate size="sm">
		<Headings main={<WelcomeBackText />} sub={<PickUpWhereYouLeftOffText />} />
		{/* everyone with a Product Collection should see a return to product experience */}
		<SiteActivation CurrentProductUser={<ReturnToProduct />} />
	</ProductCollectionOverlayTemplate>
);
